import { HeadingItem } from 'components'
import { TripContext } from 'contexts'
import React, { FC, Fragment, useContext } from 'react'
import { useOrderItemService } from 'services'
import { ReconcileReasonType, Temperature } from 'services/enums'
import { CatchWeight, LineItem, OrderItem, OrderItemChange, ReconcileReason } from 'services/types'
import './po-card.scss'

type Props = {
    customerPo: string,
    items: OrderItem[],
    onClick: () => void
}

export const POCard: FC<Props> = ({ customerPo, items, onClick }) => {
    const tripContext = useContext(TripContext)
    const { calculatedeliveredQuantity } = useOrderItemService()

    const changes: OrderItemChange[] = tripContext.orderItemChanges.toArray() ?? []
    const catchWeights: CatchWeight[] = tripContext.catchWeights.toArray() ?? []
    const reconcileReasons: ReconcileReason[] = tripContext.reconcileReasons.toArray() ?? []
    let [orderedQty, shippedQty, deliveredQty, shortQty, overageQty, refusalQty] = [0, 0, 0, 0, 0, 0]

    let deliveredQuantityDry: number = 0
    let deliveredQuantityFrozen: number = 0
    let deliveredQuantityRefrigerated: number = 0

    items.forEach(item => {
        let itemCatchWeights: CatchWeight[] = catchWeights.filter(cw => cw.orderItemId == item.id)
        if (itemCatchWeights && itemCatchWeights.length > 0) {
            let overageCatchWeights: CatchWeight[] = itemCatchWeights.filter(x => x.reconcileReasonId == ReconcileReasonType.OverageKept) ?? []
            let shortedCatchWeights: CatchWeight[] = itemCatchWeights.filter(x => x.reconcileReasonId == ReconcileReasonType.Shortage) ?? []
            let refusedCatchWeights: CatchWeight[] = itemCatchWeights.filter(x => reconcileReasons.some(reason => reason.id == x.reconcileReasonId && reason.isRefusal)) ?? []
            shippedQty += item.shippedQuantity

            overageQty += overageCatchWeights.length
            shortQty += shortedCatchWeights.length
            refusalQty += refusedCatchWeights.length
            orderedQty += item.orderedQuantity
        }
        else {
            orderedQty += item.orderedQuantity
            shippedQty += item.shippedQuantity
            let itemChanges = changes.filter(oic => oic.orderItemId == item.id)
            itemChanges?.forEach(change => {
                if (change.reconcileReasonId == ReconcileReasonType.OverageKept)
                    overageQty += change.quantity
                else if (change.reconcileReasonId == ReconcileReasonType.Shortage) {
                    shortQty += change.quantity
                }
                else {
                    refusalQty += change.quantity
                }
            })
        }

        let calculateDeliveredQuantityResult = calculatedeliveredQuantity(item, deliveredQuantityDry, deliveredQuantityFrozen, deliveredQuantityRefrigerated)
        deliveredQuantityDry = calculateDeliveredQuantityResult.deliveredQuantityDry
        deliveredQuantityFrozen = calculateDeliveredQuantityResult.deliveredQuantityFrozen
        deliveredQuantityRefrigerated = calculateDeliveredQuantityResult.deliveredQuantityRefrigerated
    })

    deliveredQty = deliveredQuantityDry + deliveredQuantityFrozen + deliveredQuantityRefrigerated;

    const hightlightDeliveredQty = () => {
        return deliveredQty != shippedQty || shortQty > 0 || overageQty > 0 || refusalQty > 0
    }

    return (
        <Fragment>
            {orderedQty > 0 &&
                <div className={'card-material'} onClick={() => onClick()}>
                    <HeadingItem text={`PO : ${customerPo}`} />
                    <div className={'po-card-content'}>
                        <div className={'po-card-subheading'}>Ordered : {orderedQty}</div>
                        <div className={'po-card-subheading'}>Shipped : {shippedQty}</div>
                        <div style={{ color: hightlightDeliveredQty() ? '#EB5757' : '#5C5C5C' }} className={'po-card-subheading'}>Delivered : {deliveredQty}</div>
                    </div>
                    <div className={'po-card-content'}>
                        <div className={'po-card-subheading'}>Short : {shortQty}</div>
                        <div className={'po-card-subheading'}>Overage : {overageQty}</div>
                        <div className={'po-card-subheading'}>Refusal : {refusalQty}</div>
                    </div>
                </div>
            }
        </Fragment>
    )
}
